import { logger } from '@/utils/logger';
import Vue from 'vue';

const state = Vue.observable({
  features: {},
  versions: {},
});

export const getters = {
  features: () => state.features,
  versions: () => state.versions,
};

export const mutations = {
  setFeatures: (features: any) => {
    state.features = features;
  },
  setVersions: (versions: any) => {
    logger.log('Set version', versions);
    state.versions = versions;
  },
};
